import axios from 'axios'
import { baseURL } from './config.js'
import qs from 'qs'
//
export default {
  uploadFiles(params) {
    const url =  baseURL + '/tbPic/modify';
    return axios.post(url, params);
  }
}


// WEBPACK FOOTER //
// ./src/api/upload.js